import { render, staticRenderFns } from "./RepartitionByRegionsChart.vue?vue&type=template&id=e7202506&"
import script from "./RepartitionByRegionsChart.vue?vue&type=script&lang=js&"
export * from "./RepartitionByRegionsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports